var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4168 16.0546C32.4168 7.20637 25.2456 0.0351562 16.3974 0.0351562C7.54914 0.0351562 0.37793 7.20637 0.37793 16.0546C0.37793 24.9029 7.54914 32.0741 16.3974 32.0741C16.4912 32.0741 16.5851 32.0741 16.679 32.0678V19.6027H13.2373V15.5915H16.679V12.638C16.679 9.21505 18.769 7.35029 21.8227 7.35029C23.287 7.35029 24.5448 7.45667 24.9077 7.50673V11.0861H22.8052C21.1469 11.0861 20.8215 11.8745 20.8215 13.0322V15.5853H24.7951L24.2757 19.5964H20.8215V31.4546C27.5171 29.5335 32.4168 23.3697 32.4168 16.0546Z",
    fill: "#DDDDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0389,
    height: 32.0389,
    fill: "white",
    transform: "translate(0.37793 0.0351562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.152e9f463d9aedbcc7bbec4910042eaa.svg";
export { ForwardRef as ReactComponent };